import { useEffect, useState } from 'react';
import { ShieldX, Home, ArrowLeft, HelpCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

const funnyMessages = [
    "Looks like you've discovered a door that wasn't meant for you.",
    "Well, this is awkward. You're not on the list.",
    "Plot twist: This area requires special clearance.",
    "Houston, we have an access problem.",
    "The bouncer says you're not on the VIP list.",
];

const AccessDenied = () => {
    const [message] = useState(() => 
        funnyMessages[Math.floor(Math.random() * funnyMessages.length)]
    );
    const [showHelp, setShowHelp] = useState(false);

    return (
        <div className="flex flex-col justify-center items-center bg-background px-4 w-screen h-screen">
            <div className="w-full max-w-lg text-center">
                {/* Icon */}
                <div className="flex justify-center mb-6">
                    <div className="p-4 bg-destructive/10 rounded-full">
                        <ShieldX className="w-16 h-16 text-destructive" strokeWidth={1.5} />
                    </div>
                </div>
                
                {/* Status code */}
                <p className="text-sm font-medium text-muted-foreground mb-2">
                    Error 403
                </p>
                
                {/* Main heading */}
                <h1 className="mb-3 font-semibold text-foreground text-2xl md:text-3xl">
                    Access Denied
                </h1>
                
                {/* Funny message */}
                <p className="mb-8 text-muted-foreground">
                    {message}
                </p>
                
                {/* Action buttons */}
                <div className="flex flex-col sm:flex-row gap-3 justify-center mb-8">
                    <a
                        href="/"
                        className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-primary text-primary-foreground rounded-md font-medium hover:bg-foreground/90 transition-colors text-sm"
                    >
                        <Home className="w-4 h-4" />
                        Go to Home
                    </a>
                    <Button
                        onClick={() => window.history.back()}
                        variant="secondary"
                        className="gap-2 px-5"
                    >
                        <ArrowLeft />
                        Go Back
                    </Button>
                </div>
                
                {/* Help section */}
                <div className="border-t pt-6">
                    <Button
                        onClick={() => setShowHelp(!showHelp)}
                        variant="ghost"
                        size="compact"
                        className="gap-2"
                    >
                        <HelpCircle />
                        {showHelp ? 'Hide details' : 'Why am I seeing this?'}
                    </Button>
                    
                    {showHelp && (
                        <div className="mt-4 p-4 bg-muted/50 rounded-lg text-left text-sm text-muted-foreground">
                            <p className="mb-2">
                                Your account doesn't have the required permissions to access this application.
                            </p>
                            <p>
                                Please contact your organization administrator to request access.
                            </p>
                        </div>
                    )}
                </div>
            </div>
            
            {/* Footer */}
            <div className="absolute bottom-6 text-center">
                <p className="text-muted-foreground/60 text-xs">
                    Need help? Contact your IT administrator
                </p>
            </div>
        </div>
    );
};

export default AccessDenied;
